import classNames from "classnames"
import * as Icons from "@nova/component-icons"
import { Tooltip } from "panels/content/top-bar/TODO-put-in-package/Tooltip"
import { ToggleSwitch } from "@nova/component-toggle-switch"

import type { JSX } from "react"

type Child = JSX.Element | null | false | undefined

type InspectorPanelAccordionKeyValueToggleProps = {
    keyTitle: string
    isToggled: boolean
    setIsToggled: (isEnabled: boolean) => void
    isInSubSection?: boolean

    /**
     * This has nothing to do with the `isToggled` prop.
     * `disabled`, when `true`, will gray out the whole
     * component and prevent clicking.
     */
    disabled?: boolean

    tooltipMessage?: string
    tooltipWidth?: number

    children?: Child | Child[]
}

export const InspectorPanelAccordionKeyValueToggle = ({
    keyTitle,
    isToggled,
    setIsToggled,
    isInSubSection = false,
    disabled = false,
    tooltipMessage,
    tooltipWidth,
    children,
}: InspectorPanelAccordionKeyValueToggleProps) => {
    return (
        <div>
            <div
                className={classNames("flex items-center justify-between gap-1 h-8 group", {
                    "text-gray-100 hover:text-gray-0": !isToggled && !disabled,
                    "text-gray-500 cursor-not-allowed": disabled,
                    "cursor-pointer": !disabled,
                    "text-gray-0": isToggled && !disabled,
                    "justify-between": isInSubSection,
                })}
                onClick={!disabled ? () => setIsToggled(!isToggled) : undefined}
            >
                <h5 className="select-none">{keyTitle}</h5>
                {tooltipMessage && (
                    <div className="relative group/tooltip">
                        <Icons.SmallIcon
                            Icon={Icons.Information}
                            className="text-gray-300 hover:text-gray-0"
                            onClick={(e) => e.stopPropagation()}
                        />
                        <Tooltip
                            title={tooltipMessage}
                            textClass="text-gray-0 text-center"
                            maxWidth={tooltipWidth}
                        />
                    </div>
                )}

                {/* Spacer */}
                <div className="flex-grow" />

                <ToggleSwitch
                    isToggled={isToggled}
                    setIsToggled={!disabled ? setIsToggled : () => {}}
                    disabled={disabled}
                />
            </div>
            {children && isToggled && <div className="mt-2">{children}</div>}
        </div>
    )
}
